import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { MachineCatalogService } from '../services/machine-catalog.service';

export const machineDetailResolver: ResolveFn<any> = async (route) => {
  const machineService = inject(MachineCatalogService);
  const id = route.paramMap.get('id');
  if (!id) return;
  machineService.machineId.set(id);
};
